// extracted by mini-css-extract-plugin
module.exports = {"privacy":"privacy_privacy__2nV8B","h2":"privacy_h2__a5LFZ","h3":"privacy_h3__Vs8vc","p":"privacy_p__3RDw-"};